export const CUSTOM_HEADER_FOOTER_TYPES: {
	HEADER: 'header';
	FOOTER: 'footer';
} = {
	HEADER: 'header',
	FOOTER: 'footer',
};
